import { render, staticRenderFns } from "./FormRegion.vue?vue&type=template&id=7798be81&"
import script from "./FormRegion.vue?vue&type=script&lang=js&"
export * from "./FormRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports